import type { WebSocketPayloadAction } from '../../actions/websocket-payload-action';
import { Deserializable } from '../../../protocols/deserializable';
import { exists } from '../../../../functions/exists';
import { BehaviorSubject, Observable } from 'rxjs';

export abstract class WebSocketSendMessage implements Deserializable {
  /**
   * This is always the locationId within the display app context.
   */
  public entityId: number;

  /**
   * What action the backend should take with this message.
   */
  public action: WebSocketPayloadAction;

  /**
   * The payload to send to the backend.
   */
  public payload: any;

  private readonly _messageSent = new BehaviorSubject<boolean>(false);
  public readonly messageSent$ = this._messageSent as Observable<boolean>;
  messageWasSent(): void {
    this._messageSent.next(true);
  }

  onDeserialize() {}

  /**
   * If the payload implements onSerialize, then return an object that serializes the payload.
   */
  onSerialize(): any {
    return exists(this.payload?.onSerialize) ? this.getWithSerializedPayload() : this;
  }

  private getWithSerializedPayload(): any {
    return {
      entityId: this.entityId,
      action: this.action,
      payload: this.onSerialize()
    };
  }

  setEntityId(entityId: number): void {
    this.entityId = entityId;
  }
}
